const FormatPeriod = (period) => {
  const [year, month] = period.split("-").map(Number);
  return new Date(year, month - 1, 1).toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });
};

const FormatReviewDate = (date) => new Date(date).toLocaleDateString();

const CanReviewReport = ({ user, organizationId }) => {
  if (user.type === "EMPLOYEE" && user.role === "ADMIN") return true;
  if (user.type === "NETWORK") {
    return (user.networkOrganizationPermissionList || []).some(
      (permission) =>
        permission.organizationId === organizationId &&
        permission.accessLevel === "FULL-ACCESS",
    );
  }
  return (
    user.type === "CUSTOMER" &&
    user.organizationId === organizationId &&
    ["DIRECTOR", "SUPERVISOR"].includes(user.role)
  );
};

export { FormatPeriod, FormatReviewDate, CanReviewReport };
